module.exports = __webpack_public_path__ + "static/futurism-63630c12c2fadcd70630c2c258f30936.svg";